import { useHistory } from 'react-router-dom'
import { useTranslation } from 'contexts/Localization'
import { QuestWithConfig, QuestSymbol } from 'state/vvsgotchi/models'
import { getVVSMinerMoleMintedUrl } from 'utils/mintedNftCollectionUrls'
import { Path } from 'config/constants/paths'
import { isMobile } from '@deficonnect/utils'
import * as ga from 'utils/googleAnalyticsHelper'

import { isGoldDiggerDisabled } from 'state/vvsgotchi/quests/goldDigger'

import ActionButton from '../ActionButton'

export const QuestCallToActionButton = ({ quest, disabled }: { quest: QuestWithConfig; disabled: boolean }) => {
  const { t } = useTranslation()
  const history = useHistory()

  switch (quest?.symbol) {
    case QuestSymbol.ADOPT:
      return (
        <ActionButton
          disabled={disabled || quest.isCompleted}
          onClick={() => {
            ga.gotchiAdoptActionBtnClick()
            bringTo(getVVSMinerMoleMintedUrl())
          }}
        >
          {t('Bring Me There')}
        </ActionButton>
      )

    case QuestSymbol.TEAM_UP:
      return (
        <ActionButton
          disabled={disabled || quest.isCompleted}
          onClick={() => {
            ga.gotchiTeamUpActionBtnClick()
            history.push(Path.VVS_GOTCHI_TEAM_SELECT)
          }}
        >
          {t('Bring Me There')}
        </ActionButton>
      )

    case QuestSymbol.BARTER:
      return (
        <ActionButton
          disabled={disabled || quest.isCompleted}
          onClick={() => {
            bringTo(Path.TRADE_SWAP)
          }}
        >
          {t('Bring Me There')}
        </ActionButton>
      )

    case QuestSymbol.MOLE_OPOLY:
      return (
        <ActionButton
          disabled={disabled || quest.isCompleted}
          onClick={() => {
            bringTo(Path.XVVS_VAULT)
          }}
        >
          {t('Bring Me There')}
        </ActionButton>
      )

    case QuestSymbol.HYDRATE:
      return (
        <ActionButton
          disabled={disabled || quest.isCompleted}
          onClick={() => {
            bringTo(Path.LIQUIDITY)
          }}
        >
          {t('Bring Me There')}
        </ActionButton>
      )

    case QuestSymbol.PROFIT:
      return (
        <ActionButton
          disabled={disabled || quest.isCompleted}
          onClick={() => {
            bringTo(Path.XVVS)
          }}
        >
          {t('Bring Me There')}
        </ActionButton>
      )

    case QuestSymbol.FARM:
      return (
        <ActionButton
          disabled={disabled || quest.isCompleted}
          onClick={() => {
            bringTo(Path.VVS_FARM)
          }}
        >
          {t('Bring Me There')}
        </ActionButton>
      )

    case QuestSymbol.GOLD_DIGGER:
      return (
        <ActionButton
          disabled={disabled || isGoldDiggerDisabled() || quest.isCompleted}
          onClick={() => {
            bringTo(Path.IGO)
          }}
        >
          {t('Bring Me There')}
        </ActionButton>
      )

    default:
      return <ActionButton disabled>{t('Quest Unavailable')}</ActionButton>
  }
}

const bringTo = (url: string) => {
  if (isMobile()) {
    window.location.href = url
  } else {
    window.open(url, '_blank')
  }
}
